import { all, call, put, takeLatest } from 'redux-saga/effects';
import { requestApi2 } from '../../../../../lib/request';
import { constants as lineConstants } from '../../line/config';
import {
  getLineServiceDetailError,
  getLineServiceDetailSuccess,
  getLineServicesError,
  getLineServicesSuccess,
} from '../actions';
import { constants, services } from '../config';

export function* getLineServicesSaga(action) {
  try {
    const { lineUuid } = action;
    console.log('Fetching services for line:', lineUuid);
    const response = yield call(requestApi2, services.getLineServices(lineUuid));
    
    if (response && response.status >= 200 && response.status < 300) {
      const { data } = response;
      yield put(getLineServicesSuccess(data));
    } else {
      yield put(getLineServicesError('Failed to fetch line services'));
    }
  } catch (error) {
    console.error('Error fetching line services:', error);
    yield put(getLineServicesError(error.message || 'Error fetching line services'));
  }
}
 
/**
 * After a line is successfully fetched, automatically load its services
 */
export function* onLineLoaded({ payload }) {
  try {
    const { lineId } = payload;
    if (lineId) {
      yield put({ type: constants.GET_LINE_SERVICES, lineUuid: lineId });
    }
  } catch {
    // silent
  }
}

export function* getLineServiceDetailSaga(action) {
  try {
    const { lineUuid, serviceSlug } = action;
    console.log('Fetching line service detail for:', lineUuid, serviceSlug);
    const response = yield call(requestApi2, services.getLineServiceDetail(lineUuid, serviceSlug));
    
    console.log('Line service detail response:', response);
    
    if (response && response.status >= 200 && response.status < 300) {
      const { data } = response;
      yield put(getLineServiceDetailSuccess(data));
    } else {
      yield put(getLineServiceDetailError('Failed to fetch line service detail'));
    }
  } catch (error) {
    console.error('Error fetching line service detail:', error);
    yield put(getLineServiceDetailError(error.message || 'Error fetching line service detail'));
  }
}

export default function* lineServicesSaga() {
  yield all([
    takeLatest(constants.GET_LINE_SERVICES, getLineServicesSaga),
    takeLatest(constants.GET_LINE_SERVICE_DETAIL, getLineServiceDetailSaga),
    // trigger services load on line success
    takeLatest(lineConstants.GET_LINE_SUCCESS, onLineLoaded),
  ]);
}
